import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Products", id: "catalog" },
  { label: "Approach", id: "manifesto" },
  { label: "Enquiry", id: "enquiry" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "glass border-b border-white/10" : ""}`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button onClick={() => (location.pathname !== "/" ? navigate("/") : window.scrollTo({ top: 0, behavior: "smooth" }))} className="flex items-center gap-3 group" data-testid="brand-logo">
          <img src="/logo.png" alt="Dashmesh Enterprises logo" className="w-9 h-9 object-contain" />
          <div className="text-left leading-none">
            <div className="font-head font-extrabold tracking-widest text-lg text-white">DASHMESH</div>
            <div className="font-mono text-[9px] tracking-[0.35em] text-signal">ENTERPRISES</div>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          <button onClick={() => navigate("/partners")} data-testid="nav-partners-page"
            className="font-mono text-xs uppercase tracking-widest text-signal hover:text-white transition-colors">
            Partners
          </button>
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-${l.id}`}
              className="font-mono text-xs uppercase tracking-widest text-slate-300 hover:text-signal transition-colors">
              {l.label}
            </button>
          ))}
          <button onClick={() => go("enquiry")} data-testid="nav-rfq-btn"
            className="font-head font-bold uppercase tracking-wider text-sm px-5 py-2 bg-signal text-ink hover:bg-signal-hover transition-colors">
            Request RFQ
          </button>
        </nav>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden glass border-t border-white/10 px-6 py-5 flex flex-col gap-4" data-testid="mobile-menu">
          <button onClick={() => { setOpen(false); navigate("/partners"); }} className="font-mono text-sm uppercase tracking-widest text-signal text-left">
            Partners
          </button>
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="font-mono text-sm uppercase tracking-widest text-slate-200 text-left">
              {l.label}
            </button>
          ))}
          <button onClick={() => go("enquiry")} className="font-head font-bold uppercase text-sm px-5 py-3 bg-signal text-ink text-center">
            Request RFQ
          </button>
        </div>
      )}
    </motion.header>
  );
}
